/**
 * Utility functions for safe price conversion and formatting
 */
import { twoDecimals, safeToDecimal } from "@/utils/precisionUtils";

/**
 * Safely converts any price value to a number with 2 decimal places
 */
export const safeParsePrice = (price: any): number => {
  return safeToDecimal(price);
};

/**
 * Formats a number as Brazilian currency
 */
export const formatBRL = (value: number): string => {
  const normalizedValue = twoDecimals(value);
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(normalizedValue);
};

/**
 * Safely calculates total from an array of items with price properties
 */
export const calculateSafeTotal = (items: any[]): number => {
  const total = items.reduce((total, item) => {
    if (item.totalPrice !== undefined) {
      return total + safeParsePrice(item.totalPrice);
    }
    
    if (item.price !== undefined && item.quantity !== undefined) {
      return total + (safeParsePrice(item.price) * item.quantity);
    }
    
    if (item.price !== undefined) {
      return total + safeParsePrice(item.price);
    }
    
    return total;
  }, 0);
  
  return twoDecimals(total);
};